// LIBRARIES //
import React, { Fragment } from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import { Row, Col } from 'antd';

// HELPERS //
import { sizes, media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';

const StyledCard = styled.div`
  color: ${colors.DARKEST_GRAY};
  border-radius: 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.125);
  text-align: left;
  padding: 24px 24px 16px 24px;
  background: #ffffff;

  ${media.mobile`
    padding: 16px;
  `};
`;

const StyledIcon = styled.img`
  width: 33px;
  height: 33px;
  margin-right: 24px;

  ${media.mobile`
    margin-right: 16px;
  `};
`;

const StyledHeaderTitle = styled.p`
  font-weight: 500;
  font-size: 18px;
  color: ${colors.CHARCOAL_GREY};
  margin: 0;
`;

const StyledHeaderTitleLink = styled.a`
  font-weight: 500;
  font-size: 18px;
  color: ${colors.DEEP_BLUE};
  cursor: pointer;
  margin: 0;
`;

const StyledSubheaderText = styled.p`
  font-size: 14px;
  color: ${colors.MED_DARK_GRAY};
  margin: 0;
`;

const StyledRightSubHeaderText = styled(StyledSubheaderText)`
  text-align: right;
`;

const IconTitleGroup = styled.div`
  display: flex;
  align-items: center;
`;

const StyledMobileDateString = styled.p`
  display: flex;
  align-items: center;
  font-size: 10px;
  color: ${colors.CHAR_COUNT};
  margin: 0;
  margin-left: ${props => (props.hasIcon ? '7px' : '0')};
`;

const Card = ({
  id,
  icon,
  title,
  propertyName,
  dateString,
  children,
  handleClick,
  rightSubHeader,
  RightIcon,
}) => {
  const colSpanLength = 24; // col length of ant design Col

  let rightSubHeaderSpan = colSpanLength;
  const rightIconSpan = 1;

  let mobileOffSet = 4; // aligns text with header title
  let mobileDateStringOffSet = mobileOffSet;
  let mobileDateStringSpan = colSpanLength - mobileDateStringOffSet;

  if (RightIcon) {
    rightSubHeaderSpan = 21; // leave room for icon
    mobileDateStringOffSet = 0; //the right icon has the offset to align the text properly
    mobileDateStringSpan += rightIconSpan;
  }
  return (
    <Fragment>
      <MediaQuery query={`(min-device-width: ${sizes.desktop}px)`}>
        <StyledCard>
          <Row>
            <Col span={10}>
              <IconTitleGroup>
                <StyledIcon src={icon} alt="" />
                <div>
                  {handleClick ? (
                    <StyledHeaderTitleLink onClick={handleClick}>{title}</StyledHeaderTitleLink>
                  ) : (
                    <StyledHeaderTitle>{title}</StyledHeaderTitle>
                  )}
                  <StyledSubheaderText>{propertyName}</StyledSubheaderText>
                </div>
              </IconTitleGroup>
            </Col>
            <Col span={12} offset={2}>
              <Row>
                <Row>
                  <Col span={rightSubHeaderSpan}>
                    <StyledRightSubHeaderText>{dateString}</StyledRightSubHeaderText>
                  </Col>
                  {RightIcon && (
                    <Col span={2} offset={1}>
                      {!rightSubHeader && RightIcon}
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col span={rightSubHeaderSpan}>
                    <StyledRightSubHeaderText>{rightSubHeader}</StyledRightSubHeaderText>
                  </Col>
                  {RightIcon && (
                    <Col span={2} offset={1}>
                      {!!rightSubHeader && RightIcon}
                    </Col>
                  )}
                </Row>
              </Row>
            </Col>
          </Row>
          {children}
        </StyledCard>
      </MediaQuery>

      <MediaQuery query={`(max-device-width: ${sizes.mobile}px)`}>
        <StyledCard>
          <Row align={'bottom'} style={{ display: 'flex' }}>
            {RightIcon && (
              <Col
                span={rightIconSpan}
                offset={mobileOffSet}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {RightIcon}
              </Col>
            )}
            <Col
              span={mobileDateStringSpan}
              offset={mobileDateStringOffSet}
              style={{ lineHeight: '10px', display: 'flex' }}
            >
              <StyledMobileDateString hasIcon={!!RightIcon}>
                {dateString}. {rightSubHeader}
              </StyledMobileDateString>
            </Col>
          </Row>
          <Row>
            <Col span={3}>
              <StyledIcon src={icon} alt="" />
            </Col>
            <Col span={20} offset={1}>
              <StyledHeaderTitle>{title}</StyledHeaderTitle>
              <StyledSubheaderText>{propertyName}</StyledSubheaderText>
            </Col>
          </Row>
          {children}
        </StyledCard>
      </MediaQuery>
    </Fragment>
  );
};

export default Card;
